import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { ROLE_LABELS } from '../utils/roleDisplay';
import Icon from './Icon';

// Sticky strip under the navbar while previewing as a lower role (read-only
// "view as"). Always on screen, so a preview can never be mistaken for the
// user's own view, and the way back is one click.
export default function ViewAsBanner() {
  const { viewAs, setViewAs } = useAuth();
  // Moves sticky filter bars / table heads below the banner (--sticky-top).
  useEffect(() => {
    if (!viewAs) return undefined;
    document.documentElement.classList.add('is-viewing-as');
    return () => document.documentElement.classList.remove('is-viewing-as');
  }, [viewAs]);
  if (!viewAs) return null;
  return (
    <div className="view-as-banner" role="status">
      <Icon name="eye" size={16} />
      {/* Copywriter pass (2026-10-03): one line on a 375px phone. Whose view,
          that it is read-only, and a way back that cannot read as "log out". */}
      <span className="view-as-banner-text">
        תצוגה כ<strong>{ROLE_LABELS[viewAs]}</strong> · קריאה בלבד
      </span>
      <button type="button" className="view-as-banner-exit" onClick={() => setViewAs(null)}>
        לתצוגה שלי
      </button>
    </div>
  );
}
